import api from "./api";

const STORAGE_KEY = "capabilities";

export async function fetchCapabilities() {
  const response = await api.get("/auth/me/capabilities");
  const data = response.data || {};
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    // localStorage full / unavailable — fall through; in-memory state still works
  }
  return data;
}

export function readCachedCapabilities() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearCachedCapabilities() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function buildSubject(capabilities) {
  if (!capabilities) return null;
  return {
    employeeId: capabilities.employeeId,
    email: capabilities.email,
    name: capabilities.name,
    role: capabilities.role,
    roles: capabilities.roles || [],
    permissions: capabilities.permissions || [],
    featureGroups: capabilities.featureGroups || {},
    superAdmin: !!capabilities.superAdmin,
  };
}

export function hasFeatureGroup(subject, featureGroupKey) {
  if (!subject || !featureGroupKey) return false;
  if (subject.superAdmin) return true;
  const fg = (subject.featureGroups || {})[featureGroupKey];
  return !!(fg && fg.hasAccess);
}
